import moment from './moment'

export default function isExpired(time) {
  const validTime = moment(time)
  const expireTime = moment()

  return validTime.isBefore(expireTime)
}
